<template>
  <b-modal
    id="modal-subjects"
    ref="my-modal"
    title="Participantes"
    no-close-on-backdrop
    ok-title="Actualizar"
    ok-only
    @ok="handleOk"
    @cancel="cancelAction"
    size="lg"
  >
    <b-overlay :show="loading" class="container-subjects">
      <div class="row mb-3">
        <div class="col-md-12">
          <h4>Destinatarios</h4>
        </div>
        <div class="col-md-12">
          <SelectSubject
            :docTypeSelected="documentTypeSelected"
            @add-subject="addSubject" v-if="!isSiss" />
          <SelectSubjectSISS
            :docTypeSelected="documentTypeSelected"
            @add-subject="addSubject"
            v-if="isSiss"
            @clear-sanitaries="clearSanitaries"
            @clear-doc-digital="clearDocDigital"
            :is-doc-digital="isDocDigital"
          />
        </div>
        <div class="col-md-12">
          <TableSubjects
            :subjects="subjects"
            v-model="subjectsSelected"
          />
        </div>
      </div>
      <div class="col-md-1">
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <h4>Con copia a</h4>
        </div>
        <div class="col-md-12">
          <SelectCopy @add-copy="addCopy" v-if="!isSiss"/>
          <SelectCopySISS
            @add-copy="addCopy"
            v-if="isSiss"
            @clear-sanitaries="clearSanitaries"
            @clear-copies-doc-digital="clearCopiesDocDigital"
            :is-doc-digital="isDocDigital"
          />
        </div>
        <div class="col-md-12">
          <TableCopies
            :copies="copies"
            v-model="copiesSelected"
          />
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>

import { BModal, VBModal } from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import { mapGetters, mapActions } from 'vuex';

import SelectSubject from '@/febos/chile/dnt/components/wizard/subjects/SelectSubject';
import SelectSubjectSISS
from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/subjects/SelectSubjectSISS';
import SelectCopy from '@/febos/chile/dnt/components/wizard/subjects/SelectCopy';
import SelectCopySISS
from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/copies/SelectCopySISS';
import TableSubjects from '@/febos/chile/dnt/components/wizard/subjects/TableSubjects';
import TableCopies from '@/febos/chile/dnt/components/wizard/subjects/TableCopies';

export default {
  components: {
    BModal,
    SelectSubject,
    SelectSubjectSISS,
    SelectCopy,
    SelectCopySISS,
    TableSubjects,
    TableCopies
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      loading: false,
      subjects: [],
      copies: [],
      subjectsSelected: [],
      copiesSelected: [],
      mappedSubjects: []
    };
  },
  watch: {
    participants() {
      this.prepareSubjects();
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Dnts', [
      'wizardData',
      'documentTypeSelected'
    ]),
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    },
    isSiss() {
      return this.company.iut === '61221000-4';
    },
    isDocDigital() {
      const arrayParticipantDocDigital = this.participants.filter((participant) => participant.destinoCodigo === 'docDigital') || [];
      return !!arrayParticipantDocDigital.length;
    }
  },
  props: {
    documentId: { type: String },
    participants: {
      type: Array,
      required: true
    },
    wizard: { required: false }
  },
  methods: {
    ...mapActions('Approvals', [
      'updateSubjectsOnFile',
    ]),
    ...mapActions('Dnts', [
      'loadFileData',
      'setDocumentInfo'
    ]),
    clearSanitaries() {
      this.subjects = this.subjects
        .filter((subject) => subject.subjectType.value !== 'sanitarias');
      this.subjectsSelected = this.subjectsSelected
        .filter((subject) => subject.subjectType.value !== 'sanitarias');
    },
    clearDocDigital() {
      this.step.subjects = this.step.subjects
        .filter((subject) => subject.subjectType.value !== 'docDigital');
      this.step.subjectsSelected = this.step.subjectsSelected
        .filter((subject) => subject.subjectType.value !== 'docDigital');
    },
    clearCopiesDocDigital() {
      this.copies = this.copies
        .filter((copies) => copies.copySubjectType.value !== 'docDigital');
      this.copiesSelected = this.copiesSelected
        .filter((copies) => copies.copySubjectType.value !== 'docDigital');
    },
    handleSubjects(subjects, copies) {
      this.mappedSubjects = [
        ...(subjects || [])
          .map((subject) => {
            const institution = Object.keys(subject.subjectTypeDigitalDoc).length
              ? {
                institucionCodigoId: subject.subjectTypeDigitalDoc.id,
                institucionCodigo: subject.subjectTypeDigitalDoc.value,
                institucionNombre: subject.subjectTypeDigitalDoc.label,
              }
              : {};

            return {
              tipoDestino: 1,
              estado: subject.status || 1,
              dntDestinatariosId: subject.dntDestinatariosId || '',
              destinoCodigoId: subject.subjectType.id,
              destinoCodigo: subject.subjectType.value,
              destinoNombre: subject.subjectType.label,
              destinoListaCodigoId: subject.subject.id,
              destinoListaCodigo: subject.subject.value,
              destinoListaNombre: subject.subject.label,
              destinoCorreo: subject.subjectEmail,
              providenciaId: subject.providence,
              providenciaVencimiento: subject.providenceExpiration,
              ...institution
            };
          }),
        ...(copies || []).map((subject) => {
          const institution = Object.keys(subject.copySubjectTypeDigitalDoc).length
            ? {
              institucionCodigoId: subject.copySubjectTypeDigitalDoc.id,
              institucionCodigo: subject.copySubjectTypeDigitalDoc.value,
              institucionNombre: subject.copySubjectTypeDigitalDoc.label,
            }
            : {};

          return {
            tipoDestino: 2,
            estado: subject.status || 1,
            dntDestinatariosId: subject.dntDestinatariosId || '',
            destinoCodigoId: subject.copySubjectType.id,
            destinoCodigo: subject.copySubjectType.value,
            destinoNombre: subject.copySubjectType.label,
            destinoListaCodigoId: subject.copySubject.id,
            destinoListaCodigo: subject.copySubject.value,
            destinoListaNombre: subject.copySubject.label,
            destinoCorreo: subject.copySubjectEmail,
            providenciaId: subject.providence,
            providenciaVencimiento: subject.providenceExpiration,
            ...institution
          };
        })
      ];
    },
    checkSelected(type) {
      if (type === 'subjects') {
        this.subjectsSelected = this.subjectsSelected.map((mapSubject) => ({
          ...mapSubject,
          status: 1
        }));
      } else {
        this.copiesSelected = this.copiesSelected.map((mapSubject) => ({
          ...mapSubject,
          status: 1
        }));
      }
      const selected = type === 'subjects'
        ? this.subjectsSelected : this.copiesSelected;
      const subjectsSelected = selected
        .filter((subject) => subject.dntDestinatariosId)
        .reduce((index, option) => ({
          ...index,
          [option.dntDestinatariosId]: option
        }), {});

      const unselected = type === 'subjects' ? this.subjects : this.copies;
      const subjectUnselected = unselected
        .filter((subject) => subject.dntDestinatariosId
          && !Object.keys(subjectsSelected).includes(subject.dntDestinatariosId))
        .map((mapSubject) => ({
          ...mapSubject,
          status: 2
        }));
      return subjectUnselected;
    },
    cancelAction() {},
    async requestActions() {
      const dntId = this.documentId;
      this.loading = true;
      try {
        await this.updateSubjectsOnFile({ fileId: dntId, subjects: this.mappedSubjects });
        await this.loadFileData({
          id: this.documentId,
          mapper: this.wizard.wizardMapper
        });
        await this.$emit('file-updated');
        await this.$bvToast.toast(
          'Se ha actualizado el expediente con la distribución',
          {
            title: 'Expediente actualizado',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 15000
          }
        );
        this.loading = false;
        this.$refs['my-modal'].hide();
      } catch (e) {
        this.loading = false;
      }
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      const unselectedSubjects = this.checkSelected('subjects');
      const unselectedCopies = this.checkSelected('copies');

      const subjects = this.subjectsSelected.concat(unselectedSubjects);
      const copies = this.copiesSelected.concat(unselectedCopies);
      this.handleSubjects(subjects, copies);
      this.requestActions();
    },
    addSubject(row) {
      const isSelected = this.subjectsSelected
        .some((subjectRow) => {
          if (subjectRow.subjectType.value === 'docDigital') return subjectRow.subjectTypeDigitalDoc.id === row.subjectTypeDigitalDoc.id;

          return subjectRow.subject.id === row.subject.id;
        });
      if (!isSelected || row.allowMultipleTimes) {
        this.subjects.push(row);
        this.subjectsSelected.push(row);
      } else {
        this.$bvToast.toast(
          'Ya agregaste este destinatario',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    async addCopy(row) {
      const isSelected = this.copiesSelected
        .some((copyRow) => {
          if (copyRow.copySubjectType.value === 'docDigital') return copyRow.copySubjectTypeDigitalDoc.id === row.copySubjectTypeDigitalDoc.id;

          return copyRow.copySubject.id === row.copySubject.id;
        });

      if (!isSelected || row.allowMultipleTimes) {
        this.copies.push(row);
        this.copiesSelected.push(row);
      } else {
        this.$bvToast.toast(
          'Ya agregaste esta copia',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    prepareSubjects() {
      const subjects = this.participants
        .filter((subject) => subject.tipoDestino.toString() === '1')
        .map((subject) => {
          const subjectTypeDigitalDoc = subject.institucionCodigo
            ? {
              id: subject.institucionCodigoId,
              value: subject.institucionCodigo,
              label: subject.institucionNombre
            }
            : {};
          return {
            subjectType: {
              id: subject.destinoCodigoId,
              value: subject.destinoCodigo,
              label: subject.destinoNombre
            },
            subject: {
              id: subject.destinoListaCodigoId,
              value: subject.destinoListaCodigo,
              label: subject.destinoListaNombre
            },
            subjectEmail: subject.destinoCorreo,
            dntId: subject.dntId,
            status: subject.estado,
            providence: subject.providenciaId || '',
            providenceExpiration: subject.providenciaVencimiento || '',
            dntDestinatariosId: subject.dntDestinatariosId,
            subjectTypeDigitalDoc
          };
        });

      this.subjects = [...subjects];
      this.subjectsSelected = [...subjects.filter((item) => +item.status === 1)];

      const copies = this.participants
        .filter((subject) => subject.tipoDestino.toString() === '2')
        .map((subject) => {
          const copySubjectTypeDigitalDoc = subject.institucionCodigo
            ? {
              id: subject.institucionCodigoId,
              value: subject.institucionCodigo,
              label: subject.institucionNombre
            }
            : {};

          return {
            copySubjectType: {
              id: subject.destinoCodigoId,
              value: subject.destinoCodigo,
              label: subject.destinoNombre
            },
            copySubject: {
              id: subject.destinoListaCodigoId,
              value: subject.destinoListaCodigo,
              label: subject.destinoListaNombre
            },
            copySubjectEmail: subject.destinoCorreo,
            providence: subject.providenciaId || '',
            dntId: subject.dntId,
            providenceExpiration: subject.providenciaVencimiento || '',
            dntDestinatariosId: subject.dntDestinatariosId,
            status: subject.estado,
            copySubjectTypeDigitalDoc
          };
        });

      this.copies = [...copies];
      this.copiesSelected = [...copies];
    }
  },
  mounted() {
    if (this.participants && this.participants.length) {
      this.prepareSubjects();
    }
  }
};
</script>
<style>
.container-subjects {
  height: 550px;
  overflow-y: scroll;
}

</style>
